module.exports = __webpack_public_path__ + "static/media/palm-trees.7644b243.jpg";